import {
  getTextStyle,
  handleLabelFormatting,
  handleTooltipFormatting,
} from "../../utils";

export const verticalArea = (
  props: { [key: string]: any } = {},
  data: { [key: string]: { [key: string]: any } | string[] } = {},
) => {
  const legendTextStyle = getTextStyle(props, "legend");
  const axisTextStyle = getTextStyle(props, "axis");
  const annotationTextStyle = getTextStyle(props, "annotation");
  const isMobile: boolean = window.innerWidth <= 768;
  let gridOptions: { [key: string]: number } = {};
  const isLegend = props.showLegend && (data.series as unknown[]).length > 1;
  let legendOptions: any = {
    show: isLegend,
    itemStyle:
      data.series.length === 1
        ? { color: "transparent", borderColor: props.color, borderWidth: 1 }
        : {},
    type: "scroll",
    itemGap: 16,
    textStyle: legendTextStyle,
  };
  const label: Record<string, unknown> = {
    show: props.showAnnotation,
    position: props.annotationPosition === "inside" ? "inside" : "right",
    formatter: (params: Record<string, string | number>) =>
      handleLabelFormatting(params, props.prefix, props.suffix),
    ...annotationTextStyle,
    color:
      props.annotationPosition !== "inside"
        ? annotationTextStyle.color
        : undefined,
  };

  if (isLegend) {
    switch (props.legendPosition) {
      case "bottom":
        legendOptions = { ...legendOptions, bottom: 0 };
        gridOptions = { top: 48 };
        break;
      case "top":
        legendOptions = { ...legendOptions, top: 0 };
        gridOptions = { bottom: 48 };
        break;
    }
  } else {
    gridOptions = { top: 25, bottom: 25 };
  }

  return {
    yAxis: {
      type: "category",
      z: 10,
      data: data.titles || [],
      boundaryGap: false,
      axisLabel: {
        hideOverlap: true,
        show: props.showAxisLabels,
        interval: 0,
        width: isMobile ? 50 : 100,
        overflow: "truncate",
        ...axisTextStyle,
      },
      tooltip: {
        show: true,
        padding: 4,
      },
    },
    tooltip: {
      formatter: (params: Record<string, string | number>) =>
        handleTooltipFormatting(params, props.prefix, props.suffix),
    },
    xAxis: {
      type: "value",
      boundaryGap: [0, 0],
      splitLine: {
        show: props.showGridlines,
        lineStyle: {
          color: props.darkMode ? "rgba(255, 255, 255, 0.15)" : "#E0E6F1",
        },
      },
      axisLabel: {
        hideOverlap: true,
        formatter: `${props.prefix ? props.prefix : ""}{value}${props.suffix ? props.suffix : ""}`,
        show: props.showAxisLabels,
        width: isMobile ? 50 : 100,
        overflow: "truncate",
        ...axisTextStyle,
      },
      tooltip: {
        show: true,
        padding: 4,
      },
    },
    title: {
      show: false,
    },
    textStyle: {
      color: props.color,
      fontFamily: props.fontFamily,
    },
    series: data.series || [],
    legend: legendOptions,
    animation: props.animation,
    label,
    labelLayout: { hideOverlap: true },
    grid: { ...gridOptions, containLabel: true, left: 10 },
  };
};
